import Config from '@skin_config';
import { POPUPS } from '@common/constants/popups';

import { getPopupDispatchers } from '../contexts/popup';
import { store } from '../index/terminalApp';

export const askForTerminalUsageConfirmationIfRequired = () => {
  const { openPopup } = getPopupDispatchers();

  const needsTerminalUsageConfirmation = (
    Config.main.enableTerminalUsageConfirmation
    && !store.getState().terminal.terminalUsageConfirmed
  );

  if (needsTerminalUsageConfirmation) openPopup(POPUPS.TERMINAL_USAGE_CONFIRMATION_POPUP);
};
